import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Home from './pages/Home';
import SecurityModal from './components/SecurityModal';
import { useSecurity } from './context/SecurityContext.jsx';
import { isElectron } from './utils/electronUtils';

// Speaking Module imports
import Class01SpeakingInstruction from './pages/Class_01/SpeakingInstruction';
import Class02SpeakingInstruction from './pages/Class_02/SpeakingInstruction';
import Class03SpeakingInstruction from './pages/Class_03/SpeakingInstruction';

import ListeningInstruction from './pages/Class_04/ListeningInstruction';
import GuidedPractice01Form from './pages/Class_04/FormCompletion/GuidedPractice01Form';
import GuidedPractice02FormTable from './pages/Class_04/FormCompletion/GuidedPractice02FormTable';
import GuidedPractice01TableNote from './pages/Class_04/NoteCompletion/GuidedPractice01TableNote';
import GuidedPractice01Note from './pages/Class_04/TableCompletion/GuidedPractice01Note';
import GuidedPractice02NoteTable from './pages/Class_04/TableCompletion/GuidedPractice02NoteTable';
import DemoGuidedPractice01 from './pages/Class_05/NoteCompletion/Class05GuidedPractice01';
import DemoGuidedPractice02 from './pages/Class_05/NoteCompletion/Class05GuidedPractice02';
import Class06ListeningInstruction from './pages/Class_06/ListeningInstruction';
import Class06GuidedPractice01 from './pages/Class_06/Class06GuidedPractice01';
import Class06GuidedPractice02 from './pages/Class_06/Class06GuidedPractice02';

import Class07ListeningInstruction from './pages/Class_07/ListeningInstruction';
import Class07GuidedPractice01 from './pages/Class_07/Class07GuidedPractice01';
import Class07GuidedPractice02 from './pages/Class_07/Class07GuidedPractice02';
import Class07GuidedPractice03 from './pages/Class_07/Class07GuidedPractice03';

import Class08ListeningInstruction from './pages/Class_08/ListeningInstruction';
import Class08GuidedPractice01 from './pages/Class_08/Class08GuidedPractice01';
import Class08GuidedPractice02 from './pages/Class_08/Class08GuidedPractice02';

import Class09ListeningInstruction from './pages/Class_09/ListeningInstruction';
import Class09GuidedPractice01 from './pages/Class_09/Class09GuidedPractice01';
import Class09GuidedPractice02 from './pages/Class_09/Class09GuidedPractice02';
import Class09GuidedPractice03 from './pages/Class_09/Class09GuidedPractice03';

// Reading Module imports
import Class10ReadingInstruction from './pages/Class_10/ReadingInstruction';
import Class10GuidedPractice01 from './pages/Class_10/Class10GuidedPractice01';
import Class10GuidedPractice02 from './pages/Class_10/Class10GuidedPractice02';
import Class11ReadingInstruction from './pages/Class_11/ReadingInstruction';
import Class11DiagramPractice01 from './pages/Class_11/Class11DiagramPractice01';
import Class11DiagramPractice02 from './pages/Class_11/Class11DiagramPractice02';
import Class11SentencePractice01 from './pages/Class_11/Class11SentencePractice01';
import Class11SentencePractice02 from './pages/Class_11/Class11SentencePractice02';
import Class11TablePractice01 from './pages/Class_11/Class11TablePractice01';
import Class11TablePractice02 from './pages/Class_11/Class11TablePractice02';
import Class11NotePractice01 from './pages/Class_11/Class11NotePractice01';
import Class11NotePractice02 from './pages/Class_11/Class11NotePractice02';
import Class12ReadingInstruction from './pages/Class_12/ReadingInstruction';
import Class12WithoutCluesPractice01 from './pages/Class_12/Class12WithoutCluesPractice01';
import Class12WithoutCluesPractice02 from './pages/Class_12/Class12WithoutCluesPractice02';
import Class12WithCluesPractice01 from './pages/Class_12/Class12WithCluesPractice01';
import Class12WithCluesPractice02 from './pages/Class_12/Class12WithCluesPractice02';
import Class13ReadingInstruction from './pages/Class_13/ReadingInstruction';
import Class13GuidedPractice01 from './pages/Class_13/Class13GuidedPractice01';
import Class13GuidedPractice02 from './pages/Class_13/Class13GuidedPractice02';
import Class13GuidedPractice03 from './pages/Class_13/Class13GuidedPractice03';
import Class14ReadingInstruction from './pages/Class_14/ReadingInstruction';
import Class14GuidedPractice01 from './pages/Class_14/Class14GuidedPractice01';
import Class14GuidedPractice02 from './pages/Class_14/Class14GuidedPractice02';
import Class15ReadingInstruction from './pages/Class_15/ReadingInstruction';
import Class15GuidedPractice01 from './pages/Class_15/Class15GuidedPractice01';
import Class15GuidedPractice02 from './pages/Class_15/Class15GuidedPractice02';
import Class16ReadingInstruction from './pages/Class_16/ReadingInstruction';
import Class16MatchingInfoPractice01 from './pages/Class_16/Class16MatchingInfoPractice01';
import Class16MatchingInfoPractice02 from './pages/Class_16/Class16MatchingInfoPractice02';
import Class16MatchingSentencePractice01 from './pages/Class_16/Class16MatchingSentencePractice01';
import Class16MatchingSentencePractice02 from './pages/Class_16/Class16MatchingSentencePractice02';

// Writing Module imports
import WritingLineCharts from './pages/writing_module/WritingLineCharts';
import WritingBarCharts from './pages/writing_module/WritingBarCharts';
import WritingPieCharts from './pages/writing_module/WritingPieCharts';
import WritingTableCharts from './pages/writing_module/WritingTableCharts';
import WritingCombinedCharts from './pages/writing_module/WritingCombinedCharts';
import WritingDiagrams from './pages/writing_module/WritingDiagrams';
import WritingMaps from './pages/writing_module/WritingMaps';
import WritingTask2Essays from './pages/writing_module/WritingTask2Essays';
import WritingTask2AdvantagesDisadvantages from './pages/writing_module/WritingTask2AdvantagesDisadvantages';
import WritingTask2Discussion from './pages/writing_module/WritingTask2Discussion';
import WritingTask2TwoPart from './pages/writing_module/WritingTask2TwoPart';

import Class17ReadingInstruction from './pages/Class_17/ReadingInstruction';
import Class17MatchingFeaturesPractice01 from './pages/Class_17/Class17MatchingFeaturesPractice01';
import Class17MatchingFeaturesPractice02 from './pages/Class_17/Class17MatchingFeaturesPractice02';
import Class17MatchingPeoplePractice01 from './pages/Class_17/Class17MatchingPeoplePractice01';
import Class10GuidedPractice03 from './pages/Class_10/Class10GuidedPractice03';

import Class18ReadingInstruction from './pages/Class_18/Class18ReadingInstruction';
import Class18GuidedPractice01 from './pages/Class_18/Class18GuidedPractice01';
import Class18GuidedPractice02 from './pages/Class_18/Class18GuidedPractice02';

import Listening_Class_01 from './pages/Combined_Classes/Listening_Class_01';
import Listening_Class_02 from './pages/Combined_Classes/Listening_Class_02';
import Reading_Class_01 from './pages/Combined_Classes/Reading_Class_01'; 


// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useSecurity();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  const { isAuthenticated, showSecurityModal, handleSecuritySubmit } = useSecurity();
  const goTo = (url) => () => (window.location.href = url);

  return (
    <Router>
      <div className="App">
        <ToastContainer position="top-right" autoClose={3000} />

        {/* Security Modal */}
        <SecurityModal
          isOpen={showSecurityModal}
          onSubmit={handleSecuritySubmit}
        />

        <Routes>
          {/* Home Page */}
          <Route path="/" element={<Home />} />

          {/* Protected Routes - Speaking Module */}
          <Route path="/class-01-speaking" element={
            <ProtectedRoute>
              <Class01SpeakingInstruction />
            </ProtectedRoute>
          } />
          <Route path="/class-02-speaking" element={
            <ProtectedRoute>
              <Class02SpeakingInstruction />
            </ProtectedRoute>
          } />
          <Route path="/class-03-speaking" element={
            <ProtectedRoute>
              <Class03SpeakingInstruction />
            </ProtectedRoute>
          } />

          {/* Protected Routes - Listening Module */}
          <Route path="/listening-instruction" element={
            <ProtectedRoute>
              <ListeningInstruction />
            </ProtectedRoute>
          } />

          {/* Protected Routes - Class_04 Pages */}
          <Route path="/guided-practice-01-form" element={
            <ProtectedRoute>
              <GuidedPractice01Form />
            </ProtectedRoute>
          } />
          <Route path="/guided-practice-02-form-table" element={
            <ProtectedRoute>
              <GuidedPractice02FormTable />
            </ProtectedRoute>
          } />
          <Route path="/guided-practice-01-table-note" element={
            <ProtectedRoute>
              <GuidedPractice01TableNote />
            </ProtectedRoute>
          } />
          <Route path="/guided-practice-01-note" element={
            <ProtectedRoute>
              <GuidedPractice01Note />
            </ProtectedRoute>
          } />
          <Route path="/guided-practice-02-note-table" element={
            <ProtectedRoute>
              <GuidedPractice02NoteTable />
            </ProtectedRoute>
          } />

          {/* Protected Routes - Class_05 Pages */}
          <Route path="/class-05-guided-practice-01" element={
            <ProtectedRoute>
              <DemoGuidedPractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-05-guided-practice-02" element={
            <ProtectedRoute>
              <DemoGuidedPractice02 />
            </ProtectedRoute>
          } />

          {/* Protected Routes - Class_06 Pages */}
          <Route path="/class-06-listening-instruction" element={
            <ProtectedRoute>
              <Class06ListeningInstruction />
            </ProtectedRoute>
          } />
          <Route path="/class-06-guided-practice-01" element={
            <ProtectedRoute>
              <Class06GuidedPractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-06-guided-practice-02" element={
            <ProtectedRoute>
              <Class06GuidedPractice02 />
            </ProtectedRoute>
          } />

          {/* Protected Routes - Class_07 Pages */}
          <Route path="/class-07-listening-instruction" element={
            <ProtectedRoute>
              <Class07ListeningInstruction />
            </ProtectedRoute>
          } />
          <Route path="/class-07-guided-practice-01" element={
            <ProtectedRoute>
              <Class07GuidedPractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-07-guided-practice-02" element={
            <ProtectedRoute>
              <Class07GuidedPractice02 />
            </ProtectedRoute>
          } />
          <Route path="/class-07-guided-practice-03" element={
            <ProtectedRoute>
              <Class07GuidedPractice03 />
            </ProtectedRoute>
          } />

          {/* Protected Routes - Class_08 Pages */}
          <Route path="/class-08-listening-instruction" element={
            <ProtectedRoute>
              <Class08ListeningInstruction />
            </ProtectedRoute>
          } />
          <Route path="/class-08-guided-practice-01" element={
            <ProtectedRoute>
              <Class08GuidedPractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-08-guided-practice-02" element={
            <ProtectedRoute>
              <Class08GuidedPractice02 />
            </ProtectedRoute>
          } />

          {/* Protected Routes - Class_09 Pages */}
          <Route path="/class-09-listening-instruction" element={
            <ProtectedRoute>
              <Class09ListeningInstruction />
            </ProtectedRoute>
          } />
          <Route path="/class-09-guided-practice-01" element={
            <ProtectedRoute>
              <Class09GuidedPractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-09-guided-practice-02" element={
            <ProtectedRoute>
              <Class09GuidedPractice02 />
            </ProtectedRoute>
          } />
          <Route path="/class-09-guided-practice-03" element={
            <ProtectedRoute>
              <Class09GuidedPractice03 />
            </ProtectedRoute>
          } />

          {/* Protected Routes - Class_10 Pages */}
          <Route path="/class-10-reading-instruction" element={
            <ProtectedRoute>
              <Class10ReadingInstruction />
            </ProtectedRoute>
          } />
          <Route path="/class-10-flowchart-practice-01" element={
            <ProtectedRoute>
              <Class10GuidedPractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-10-flowchart-practice-02" element={
            <ProtectedRoute>
              <Class10GuidedPractice02 />
            </ProtectedRoute>
          } />
          <Route path="/class-10-shortq-practice-01" element={
            <ProtectedRoute>
              <Class10GuidedPractice03 />
            </ProtectedRoute>
          } />

          {/* Protected Routes - Class_11 Pages */}
          <Route path="/class-11-reading-instruction" element={
            <ProtectedRoute>
              <Class11ReadingInstruction />
            </ProtectedRoute>
          } />
          <Route path="/class-11-diagram-practice-01" element={
            <ProtectedRoute>
              <Class11DiagramPractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-11-diagram-practice-02" element={
            <ProtectedRoute>
              <Class11DiagramPractice02 />
            </ProtectedRoute>
          } />
          <Route path="/class-11-sentence-practice-01" element={
            <ProtectedRoute>
              <Class11SentencePractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-11-sentence-practice-02" element={
            <ProtectedRoute>
              <Class11SentencePractice02 />
            </ProtectedRoute>
          } />
          <Route path="/class-11-table-practice-01" element={
            <ProtectedRoute>
              <Class11TablePractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-11-table-practice-02" element={
            <ProtectedRoute>
              <Class11TablePractice02 />
            </ProtectedRoute>
          } />
          <Route path="/class-11-note-practice-01" element={
            <ProtectedRoute>
              <Class11NotePractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-11-note-practice-02" element={
            <ProtectedRoute>
              <Class11NotePractice02 />
            </ProtectedRoute>
          } />

          {/* Protected Routes - Class_12 Pages */}
          <Route path="/class-12-reading-instruction" element={
            <ProtectedRoute>
              <Class12ReadingInstruction />
            </ProtectedRoute>
          } />
          <Route path="/class-12-without-clues-practice-01" element={
            <ProtectedRoute>
              <Class12WithoutCluesPractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-12-without-clues-practice-02" element={
            <ProtectedRoute>
              <Class12WithoutCluesPractice02 />
            </ProtectedRoute>
          } />
          <Route path="/class-12-with-clues-practice-01" element={
            <ProtectedRoute>
              <Class12WithCluesPractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-12-with-clues-practice-02" element={
            <ProtectedRoute>
              <Class12WithCluesPractice02 />
            </ProtectedRoute>
          } />

          {/* Protected Routes - Class_13 Pages */}
          <Route path="/class-13-reading-instruction" element={
            <ProtectedRoute>
              <Class13ReadingInstruction />
            </ProtectedRoute>
          } />
          <Route path="/class-13-practice-01" element={
            <ProtectedRoute>
              <Class13GuidedPractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-13-practice-02" element={
            <ProtectedRoute>
              <Class13GuidedPractice02 />
            </ProtectedRoute>
          } />
          <Route path="/class-13-practice-03" element={
            <ProtectedRoute>
              <Class13GuidedPractice03 />
            </ProtectedRoute>
          } />

          {/* Protected Routes - Class_14 Pages */}
          <Route path="/class-14-reading-instruction" element={
            <ProtectedRoute>
              <Class14ReadingInstruction />
            </ProtectedRoute>
          } />
          <Route path="/class-14-practice-01" element={
            <ProtectedRoute>
              <Class14GuidedPractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-14-practice-02" element={
            <ProtectedRoute>
              <Class14GuidedPractice02 />
            </ProtectedRoute>
          } />

          {/* Protected Routes - Class_15 Pages */}
          <Route path="/class-15-reading-instruction" element={
            <ProtectedRoute>
              <Class15ReadingInstruction />
            </ProtectedRoute>
          } />
          <Route path="/class-15-practice-01" element={
            <ProtectedRoute>
              <Class15GuidedPractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-15-practice-02" element={
            <ProtectedRoute>
              <Class15GuidedPractice02 />
            </ProtectedRoute>
          } />

          {/* Protected Routes - Class_16 Pages */}
          <Route path="/class-16-reading-instruction" element={
            <ProtectedRoute>
              <Class16ReadingInstruction />
            </ProtectedRoute>
          } />
          <Route path="/class-16-matching-info-practice-01" element={
            <ProtectedRoute>
              <Class16MatchingInfoPractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-16-matching-info-practice-02" element={
            <ProtectedRoute>
              <Class16MatchingInfoPractice02 />
            </ProtectedRoute>
          } />
          <Route path="/class-16-matching-sentence-practice-01" element={
            <ProtectedRoute>
              <Class16MatchingSentencePractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-16-matching-sentence-practice-02" element={
            <ProtectedRoute>
              <Class16MatchingSentencePractice02 />
            </ProtectedRoute>
          } />

          {/* Protected Routes - Writing Module */}
          <Route path="/writing-line-charts" element={
            <ProtectedRoute>
              <WritingLineCharts />
            </ProtectedRoute>
          } />
          <Route path="/writing-bar-charts" element={
            <ProtectedRoute>
              <WritingBarCharts />
            </ProtectedRoute>
          } />
          <Route path="/writing-pie-charts" element={
            <ProtectedRoute>
              <WritingPieCharts />
            </ProtectedRoute>
          } />
          <Route path="/writing-table-charts" element={
            <ProtectedRoute>
              <WritingTableCharts />
            </ProtectedRoute>
          } />
          <Route path="/writing-combined-charts" element={
            <ProtectedRoute>
              <WritingCombinedCharts />
            </ProtectedRoute>
          } />
          <Route path="/writing-diagrams" element={
            <ProtectedRoute>
              <WritingDiagrams />
            </ProtectedRoute>
          } />
          <Route path="/writing-maps" element={
            <ProtectedRoute>
              <WritingMaps />
            </ProtectedRoute>
          } />
          <Route path="/writing-task2-essays" element={
            <ProtectedRoute>
              <WritingTask2Essays />
            </ProtectedRoute>
          } />
          <Route path="/writing-task2-advantages-disadvantages" element={
            <ProtectedRoute>
              <WritingTask2AdvantagesDisadvantages />
            </ProtectedRoute>
          } />
          <Route path="/writing-task2-discussion" element={
            <ProtectedRoute>
              <WritingTask2Discussion />
            </ProtectedRoute>
          } />
          <Route path="/writing-task2-two-part" element={
            <ProtectedRoute>
              <WritingTask2TwoPart />
            </ProtectedRoute>
          } />

          {/* Protected Routes - Class_17 Pages */}
          <Route path="/class-17-reading-instruction" element={
            <ProtectedRoute>
              <Class17ReadingInstruction />
            </ProtectedRoute>
          } />
          <Route path="/class-17-matching-features-practice-01" element={
            <ProtectedRoute>
              <Class17MatchingFeaturesPractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-17-matching-features-practice-02" element={
            <ProtectedRoute>
              <Class17MatchingFeaturesPractice02 />
            </ProtectedRoute>
          } />
          <Route path="/class-17-matching-people-practice-01" element={
            <ProtectedRoute>
              <Class17MatchingPeoplePractice01 />
            </ProtectedRoute>
          } />

          {/* Protected Routes - Class_18 Pages */}
          <Route path="/class-18-reading-instruction" element={
            <ProtectedRoute>
              <Class18ReadingInstruction />
            </ProtectedRoute>
          } />
          <Route path="/class-18-practice-01" element={
            <ProtectedRoute>
              <Class18GuidedPractice01 />
            </ProtectedRoute>
          } />
          <Route path="/class-18-practice-02" element={
            <ProtectedRoute>
              <Class18GuidedPractice02 />
            </ProtectedRoute>
          } />

          {/* Protected Route - CD Class 01 Basic Computer Class (Mouse & Keyboard Practice) */}
          <Route path="/cd-class-02-ielts-listening-interface-practice" element={
            <Listening_Class_01 />
          } />


          <Route path="/cd-class-03-ielts-listening-interface-practice" element={
            <Listening_Class_02 />
          } />

          <Route path="/cd-class-04-ielts-reading-interface-practice" element={
            <Reading_Class_01 />
          } />

        </Routes>
      </div>
    </Router>
  );
}

export default App;
